import http from '@/fetch/http'
import * as types from '@/vuex/types'
import Vue from 'vue'
const state = {
  // title
  showTitleslide: false,
  // title modal
  showTablemodal: false,
  // 题目
  showTopic: false,
  // 票据
  showBill: false,
  // 盖章
  showStamp: false,
  // 专业题高亮
  showGaoliang: false,
  //画线
  showDrawline: false,
  //符号
  showSymbol: false,
  showTest: 'true',
  //当前页数
  pageNum: 0,
  //显示一个章
  showStampOne: false,
  //所有章
  stampSrcList:[],
  //滚动条高度
  scrallHeight: '',
  //盖章地址
  stampAddress:'',
  //禁止滑动
  noSwiping: false,
  stampInfo: {},
  // 上一题和下一题 和表格的空有关
  showElementIndex: -1,
  // 滚动条锁定
  scrollFlag: 0
}
const actions = {
  // title slide
  setTitleSlide({commit}, flag){
    commit('showtitleslide', flag)
  },
  setStampInfo({commit}, info) {
    commit('setStampInfo', info)
  },
  setGaoliang({commit}, flag) {
    commit('SHOW_GAO_LIANG', flag)
  },
  setTablemodalMethod({commit}, type) {
    commit('showtablemodalMethod', type)
  },
  // table element index 开关
  setTableIndex({commit}, index) {
    commit('settableindex', index)
  },


  setShowStampOne({commit}, status) {
    commit('SET_SHOW_STAMP_ONE', status)
  },
  setStampSrcList({commit}, srcList) {
    commit('setStampSrcList', srcList)
  },
  setScrallHeight({commit}, height) {
    commit('setScrallHeight', height)
  },
  setStampAddress({commit}, address) {
    commit('setStampAddress', address)
  },
  setNoSwiping({commit}, status) {
    commit('setNoSwiping', status)
  },
  lockScroll({commit}){
  	return;
    // 第一次添加禁止滚动没生效，touchmouve触发次数过多，只绑定前两次
    if(state.scrollFlag>1){
      return;
    }
    var mo=function(e){e.preventDefault();};
    document.body.style.overflow='hidden';
    document.addEventListener("touchmove",mo,false);//禁止页面滑动
    commit('SET_SCROLLFLAG',state.scrollFlag+1);
  },
  unlockScroll({commit}){
  	return;
    var mo=function(e){e.preventDefault();};
    //document.body.style.overflow=null;//出现滚动条
    document.body.removeAttribute("style");
    document.removeEventListener("touchmove",mo,false);
    commit('SET_SCROLLFLAG',0);
  }
}
const getters = {}
const mutations = {
  setStampInfo(state, info) {
    state.stampInfo = info;
  },
  setStampSrcList(state, srcList) {
    if(srcList == 0){
      state.stampSrcList.pop();
    }else{
      state.stampSrcList.push(srcList);
    }
  },
  setNoSwiping(state, status) {
    state.noSwiping = status;
  },
  setStampAddress(state, address) {
    state.stampAddress = address;
  },
  setScrallHeight(state, height) {
    state.scrallHeight = height;
  },
  showtitleslide(state,flag) {
    // 0,1 2自动切换
    if(flag == 0) {
      state.showTitleslide = false;
    } else if(flag == 1) {
      state.showTitleslide = true;
    } else if(flag == 2){
      state.showTitleslide = !state.showTitleslide;
    }

  },
  SHOW_GAO_LIANG(state) {
    state.showGaoliang = !state.showGaoliang;
  },
  SET_SHOW_STAMP_ONE(state,status){
    state.showStampOne = status;
    state.showStamp = status;
  },
  showtablemodalMethod(state, type) {
    // 0 关闭 1题目  2 票据 3 盖章 4 画线
    if (type == 0) {
      state.showTablemodal = false;
      state.showTopic = false;
      state.showBill = false;
      state.showStamp = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 1) {
      state.showTablemodal = !state.showTablemodal;
      state.showTopic = !state.showTopic;
      state.showBill = false;
      state.showStamp = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 2) {
      state.showTablemodal = !state.showTablemodal;
      state.showBill = !state.showBill;
      state.showTopic = false;
      state.showStamp = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 3) {
      state.showTablemodal = !state.showTablemodal;
      state.showStamp = !state.showStamp;
      state.showTopic = false;
      state.showBill = false;
      state.showDrawline = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 4) {
      state.showTablemodal = !state.showTablemodal;
      state.showDrawline = !state.showDrawline;
      state.showTopic = false;
      state.showBill = false;
      state.showStamp = false;
      state.showSymbol = false;
      return ;
    }
    if (type == 5) {
      state.showTablemodal = !state.showTablemodal;
      state.showSymbol = !state.showSymbol;
      state.showTopic = false;
      state.showBill = false;
      state.showStamp = false;
      state.showDrawline = false;
      return ;
    }
    return ;
  },
  // table index
  settableindex(state,index){
    state.showElementIndex = index;
  },
  ['SET_SCROLLFLAG'](state,flag){
    Vue.set(state,'scrollFlag',flag);
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/student/status.js